import { normalizeConnectionValueSource } from './connectionEffectiveValue.js'

export const DEFAULT_CONNECTION_DATA = Object.freeze({ min: 0, max: 100, value: 0, value_source: 'own' })

function canonicalNumber(value, fallback) {
    if (value === null || value === undefined || value === '') return fallback
    const number = Number(value)
    return Number.isFinite(number) ? number : fallback
}

export function canonicalConnectionData(source) {
    return {
        min: canonicalNumber(source?.min, DEFAULT_CONNECTION_DATA.min),
        max: canonicalNumber(source?.max, DEFAULT_CONNECTION_DATA.max),
        value: canonicalNumber(source?.value, DEFAULT_CONNECTION_DATA.value),
        value_source: normalizeConnectionValueSource(source?.value_source),
    }
}
